<template>
  <div class="op-images">
    <card title="Before / After photos">
      <div class="op-images__toolbar">
        <el-select
          v-model="selectedOperationId"
          placeholder="Filter by operation"
          clearable
          filterable
          no-data-text="No data"
          no-match-text="No match"
          class="op-images__filter"
        >
          <el-option
            v-for="op in operations"
            :key="op.id"
            :label="op.name && op.name.en ? op.name.en : op.id"
            :value="op.id"
          />
        </el-select>
        <base-button type="primary" @click="openUpload">+ Add photo</base-button>
      </div>

      <div class="op-images__list" v-if="images.length">
        <div
          v-for="img in images"
          :key="img.id"
          class="op-images__item"
          @click="openEdit(img)"
        >
          <img :src="img.url" :alt="img.id"/>
          <div class="op-images__item-meta">
            <span v-if="img.operation_id">op#{{ img.operation_id }}</span>
            <span v-if="img.year">· {{ img.year }}</span>
            <span v-if="img.patient_age">· {{ img.patient_age }}y</span>
          </div>
          <i class="op-images__item-edit fa fa-pencil-alt"></i>
        </div>
      </div>
      <div v-else class="card-body">No photos yet</div>
    </card>

    <UploadDialog
      :visible.sync="uploadVisible"
      :clinic-id="clinic.id"
      :operations="operations"
      @saved="refresh"
    />

    <EditDialog
      :visible.sync="editVisible"
      :image="editingImage"
      :operations="operations"
      @saved="refresh"
      @deleted="refresh"
    />
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import UploadDialog from './UploadDialog.vue';
import EditDialog from './EditDialog.vue';

export default {
  components: { UploadDialog, EditDialog },
  data: () => ({
    selectedOperationId: null,
    uploadVisible: false,
    editVisible: false,
    editingImage: null,
  }),
  computed: {
    ...mapState('clinics', ['clinic']),
    ...mapState('cmsApiCatalogs', ['operations']),
    ...mapGetters('operationResultImages', ['images']),
  },
  watch: {
    selectedOperationId() {
      this.refresh();
    },
    'clinic.id': {
      immediate: false,
      handler(id) {
        if (id) this.refresh();
      },
    },
  },
  mounted() {
    this.refresh();
  },
  methods: {
    ...mapActions('operationResultImages', ['fetch']),
    refresh() {
      if (!this.clinic || !this.clinic.id) return;
      const params = { clinic_id: this.clinic.id };
      if (this.selectedOperationId) {
        params.operation_id = this.selectedOperationId;
      } else {
        params.limit = 100;
      }
      return this.fetch(params);
    },
    openUpload() {
      this.uploadVisible = true;
    },
    openEdit(img) {
      this.editingImage = img;
      this.editVisible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.op-images {
  &__toolbar {
    display: flex;
    gap: 12px;
    align-items: center;
    margin-bottom: 16px;
    padding: 0 16px;
  }
  &__filter {
    width: 320px;
  }
  &__list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
    gap: 12px;
    padding: 0 16px 16px;
  }
  &__item {
    position: relative;
    border: 1px solid #e3e5e8;
    border-radius: 6px;
    overflow: hidden;
    cursor: pointer;
    transition: box-shadow 0.15s;
    &:hover {
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }
    img {
      width: 100%;
      height: 180px;
      object-fit: cover;
      display: block;
    }
  }
  &__item-meta {
    padding: 6px 8px;
    font-size: 12px;
    color: #555;
    background: #fafafa;
    border-top: 1px solid #eee;
  }
  &__item-edit {
    position: absolute;
    top: 8px;
    right: 8px;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 50%;
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #a3cc0e;
  }
}
</style>
